export const generateInitialPositions = (products?: order.CheckPriceProductObject): order.Position[] => {
  const { search } = window.location
  if (!products || !search || !search.includes('productKey')) {
    return []
  }

  const query = new URLSearchParams(search)
  const additionalProfiles = query.get('additionalProfiles')
  const relatedObject = query.get('relatedObject')
  const profileName = query.get('profileName')
  const productKey = query.get('productKey')
  const relatedId = query.get('relatedId')
  const product = findProduct(products, productKey)
  if (product) {
    const position: order.Position = {
      cartId: crypto.randomUUID(),
      id: product.product_id,
      amount: 1,
      addons: {}
    }

    if (relatedObject && relatedId) {
      position.params = {
        related: {
          id: relatedId,
          object: relatedObject
        }
      }
    }

    if (profileName) {
      position.profileName = profileName
    }

    if (productKey === 'qr_board' && additionalProfiles) {
      const additionalProfilesNumber = Number(additionalProfiles)
      const addon = product.order_params.addons.find(addon => addon.key === 'additional_profile')
      if (addon && additionalProfilesNumber) {
        position.addons = {
          [addon.id]: additionalProfilesNumber
        }
      }
    }

    return [position]

  } else {
    return []
  }
}

const groupCartPositionByType = (positions: order.Position[]) => {
  return positions.reduce((r, { id, amount, addons }) => {
    r[id] = (r[id] || 0) + amount
    const addonsList = Object.entries(addons)
    if (addonsList.length > 0) {
      addonsList.forEach(([id, amount]) => {
        r[id] = (r[id] || 0) + amount
      })
    }
    return r
  }, {} as Record<string, number>)
}

export type DiscountsObject = Record<string, Discounts>
interface Discounts {
  current: number
  next: number
}

export const checkPositionsDiscounts = (positions: order.Position[], products?: order.CheckPriceProductObject) => {
  const prices: DiscountsObject = {}
  if (prices) {
    const positionGroupedByType = groupCartPositionByType(positions)
    for (const id in positionGroupedByType) {
      const positionAmount = positionGroupedByType[id] || 0
      const discounts = products?.[id]?.discounts?.percentages

      if (discounts) {
        const heightDiscount = Object.keys(discounts).at(-1)
        const currentDiscount = (discounts[positionAmount] || (heightDiscount ? discounts[Number(heightDiscount)] : { percentage: 100 }))
        const nextDiscount = (discounts[positionAmount + 1] || (heightDiscount ? discounts[Number(heightDiscount)] : { percentage: 100 }))
        prices[id] = {
          current: 100 - currentDiscount.percentage,
          next: 100 - nextDiscount.percentage
        }
      } else {
        prices[id] = {
          current: 0,
          next: 0
        }
      }
    }
  }
  return prices
}

export const checkIsDeliveryRequired = (positions: order.Position[], products?: order.CheckPriceProductObject) => {
  if (!products) return false
  for (const position of positions) {
    if (products[position.id]?.order_params?.deliveries && products[position.id].order_params.deliveries.length > 0) {
      return true
    }
  }
  return false
}

export const findProduct = (products?: order.CheckPriceProductObject, productKey?: string | null) => {
  if (!products || !productKey) return
  for (const key in products) {
    if (products[key].product_key === productKey) {
      return products[key]
    }
  }
}

export const getAvailableDeliveries = (products?: order.CheckPriceProductObject) => {
  if (!products) return
  for (const key in products) {
    const list = products[key].order_params.deliveries
    if (list && list.length > 0) {
      return {
        list,
        deliveryHtml: products[key].order_params.delivery_html
      }
    }
  }
}

export const getAvailablePaymentMethods = (products?: order.CheckPriceProductObject) => {
  if (!products) return
  for (const key in products) {
    const list = products[key].order_params.payments
    if (list && list.length > 0) {
      return list
    }
  }
}

export const generateCartBody = (cart: order.Cart, blik?: string): order.OrderBody => {
  return {
    ...cart,
    blik,
    positions: cart.positions.map(({ id, amount, addons, params }) => {
      return {
        product_id: id,
        amount,
        params,
        addons: Object.entries(addons).reduce((r, [product_id, amount]) => {
          if (amount > 0) r.push({ product_id, amount })
          return r
        }, [] as order.PositionAddon[])
      }
    })
  }
}

export const getDeliveryData = (selectedDeliveryKey?: order.Cart['selected_delivery'], products?: order.CheckPriceProductObject) => {
  if (!products || !selectedDeliveryKey) {
    return
  }

  for (const key in products) {
    const selectedDelivery = products[key].order_params.deliveries?.find(delivery => delivery.key === selectedDeliveryKey)
    if (selectedDelivery) return selectedDelivery
  }
}
